import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = ({onModalClose}: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return (
                    <div className={summaryHeading}>
                        <div className={summaryClose}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>

                        <div className={summaryTexts}>
                            <Text variant="headline_3" as="p" align="center" className={summaryHeadline}>
                                Dziękujemy za Twoje zgłoszenie
                            </Text>

                            <Text variant="body_copy_1" align="center">
                                Nasz konsultant skontaktuje się z Tobą w przeciągu 48 godzin, aby dopytać o szczegóły i przedstawić pierwsze propozycje
                                mieszkań.
                            </Text>
                        </div>
                    </div>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div className={additionalHeading}>
                        <div className={movingClose}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>
                        <DialogComponent />
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div className={baseHeading}>
                        <ProgressComponent onModalClose={onModalClose} />
                    </div>
                ) : (
                    <div className={minimalHeadingStyle}>
                        <div style={{cursor: "pointer"}}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>
                    </div>
                );
            default:
                return (
                    <div className={baseHeading}>
                        <ProgressComponent onModalClose={onModalClose} />
                        <DialogComponent />
                    </div>
                );
        }
    };

    return renderHeading();
};

const CloseButton = ({onModalClose}: {onModalClose: () => void}) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const ProgressComponent = ({onModalClose}: {onModalClose: () => void}) => (
    <div className={progressWrapper}>
        <ForYouModalProgress />
        <div className={css({cursor: "pointer"})}>
            <CloseButton onModalClose={onModalClose} />
        </div>
    </div>
);

const DialogComponent = () => (
    <div className={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox className={consultantBox} />
    </div>
);

const summaryHeading = css({
    bgColor: "var(--colors-gray-100)",
    ml: -2,
    p: "3.5rem 2rem 2rem 2rem",

    md: {
        p: "5rem 12rem"
    }
});

const summaryClose = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,

    md: {
        position: "absolute",
        top: "3.5rem",
        right: "3.5rem"
    }
});

const summaryTexts = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    alignItems: "center"
});

const summaryHeadline = css({
    mx: 5,

    md: {
        m: "unset"
    }
});

const additionalHeading = css({
    display: "flex",
    flexDirection: "column",
    ml: -2,
    bg: "var(--colors-gray-100)",
    p: "1.5rem",
    gap: 2,

    md: {
        p: "2rem 9rem 4rem 4rem"
    }
});

const movingClose = css({
    display: "flex",
    justifyContent: "end",
    cursor: "pointer",

    md: {
        position: "absolute",
        top: "3.5rem",
        right: "3.5rem"
    }
});

const baseHeading = css({
    display: "flex",
    flexDirection: "column",
    ml: -2,
    bgColor: "var(--colors-gray-100)",
    p: "1.5rem",
    gap: 3,

    md: {
        p: "3rem 4rem 4rem 4rem"
    }
});

const minimalHeadingStyle = css({
    display: "flex",
    justifyContent: "end",
    ml: -2,
    p: "1.5rem",

    md: {
        pt: 3,
        pr: 4
    }
});

const progressWrapper = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 2
});

const consultantDialog = css({
    display: "flex",
    flexDirection: "row",
    gap: 1,

    md: {
        gap: 3
    }
});

const consultantBox = css({
    bgColor: "var(--colors-white)",
    flexDirection: "column !important",
    justifyContent: "center",
    minWidth: 144,

    "& p": {
        textAlign: "center"
    },

    md: {
        flexDirection: "row !important",
        justifyContent: "start",
        minWidth: 234,

        "& p": {
            textAlign: "start"
        }
    }
});
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = ({onModalClose}: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return (
                    <div className={summaryHeading}>
                        <div className={summaryClose}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>

                        <div className={summaryTexts}>
                            <Text variant="headline_3" as="p" align="center" className={summaryHeadline}>
                                Dziękujemy za Twoje zgłoszenie
                            </Text>

                            <Text variant="body_copy_1" align="center">
                                Nasz konsultant skontaktuje się z Tobą w przeciągu 48 godzin, aby dopytać o szczegóły i przedstawić pierwsze propozycje
                                mieszkań.
                            </Text>
                        </div>
                    </div>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div className={additionalHeading}>
                        <div className={movingClose}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>
                        <DialogComponent />
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div className={baseHeading}>
                        <ProgressComponent onModalClose={onModalClose} />
                    </div>
                ) : (
                    <div className={minimalHeadingStyle}>
                        <div style={{cursor: "pointer"}}>
                            <CloseButton onModalClose={onModalClose} />
                        </div>
                    </div>
                );
            default:
                return (
                    <div className={baseHeading}>
                        <ProgressComponent onModalClose={onModalClose} />
                        <DialogComponent />
                    </div>
                );
        }
    };

    return renderHeading();
};

const CloseButton = ({onModalClose}: {onModalClose: () => void}) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const ProgressComponent = ({onModalClose}: {onModalClose: () => void}) => (
    <div className={progressWrapper}>
        <ForYouModalProgress />
        <div className={css({cursor: "pointer"})}>
            <CloseButton onModalClose={onModalClose} />
        </div>
    </div>
);

const DialogComponent = () => (
    <div className={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox className={consultantBox} />
    </div>
);

const summaryHeading = css({
    bgColor: "var(--colors-gray-100)",
    ml: -2,
    p: "3.5rem 2rem 2rem 2rem",

    md: {
        p: "5rem 12rem"
    }
});

const summaryClose = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,

    md: {
        position: "absolute",
        top: "3.5rem",
        right: "3.5rem"
    }
});

const summaryTexts = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    alignItems: "center"
});

const summaryHeadline = css({
    mx: 5,

    md: {
        m: "unset"
    }
});

const additionalHeading = css({
    display: "flex",
    flexDirection: "column",
    ml: -2,
    bg: "var(--colors-gray-100)",
    p: "1.5rem",
    gap: 2,

    md: {
        p: "2rem 9rem 4rem 4rem"
    }
});

const movingClose = css({
    display: "flex",
    justifyContent: "end",
    cursor: "pointer",

    md: {
        position: "absolute",
        top: "3.5rem",
        right: "3.5rem"
    }
});

const baseHeading = css({
    display: "flex",
    flexDirection: "column",
    ml: -2,
    bgColor: "var(--colors-gray-100)",
    p: "1.5rem",
    gap: 3,

    md: {
        p: "3rem 4rem 4rem 4rem"
    }
});

const minimalHeadingStyle = css({
    display: "flex",
    justifyContent: "end",
    ml: -2,
    p: "1.5rem",

    md: {
        pt: 3,
        pr: 4
    }
});

const progressWrapper = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 2
});

const consultantDialog = css({
    display: "flex",
    flexDirection: "row",
    gap: 1,

    md: {
        gap: 3
    }
});

const consultantBox = css({
    bgColor: "var(--colors-white)",
    flexDirection: "column !important",
    justifyContent: "center",
    minWidth: 144,

    "& p": {
        textAlign: "center"
    },

    md: {
        flexDirection: "row !important",
        justifyContent: "start",
        minWidth: 234,

        "& p": {
            textAlign: "start"
        }
    }
});
